import { Typography } from "@material-ui/core";
import React from "react";
export const getEmailValidation = () => ({
  pattern: {
    value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
    message: "Please enter a valid email address",
  },
});
const getNestedValue = (obj, path) => {
  return path.split(".").reduce((acc, part) => acc?.[part], obj);
};
export const renderError = (errors, name) => {
  const error = getNestedValue(errors, name);
  return error?.message ? (
    <Typography variant="body2" color="error">
      {error.message}
    </Typography>
  ) : null;
};
